import React       from 'react';
import ReactDom    from 'react-dom';

import S3Upload    from 's3_upload';
// -------------------------------------------------------

class InputImage extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      event : {},
      upload_url : '',
    }
  }
  // -------------------------------------------------------
  
  /*
   * イベント設定
   */
  setEvent(column, ev) {
    let event = this.state.event;
    event[column] = ev;
    this.setState({ event: event });
  }
  // -------------------------------------------------------
  
  /*
   * データ更新時反映
   */
  actionProgress() {
    let media = this.state.event.get_media.bind(this)();
    let last_media = media[(media.length - 1)];
    
    if( last_media.progress == 100 ){
      this.props.update_ev.bind(this)(last_media.url);
      this.setState({ upload_url: last_media.url });
    }
  }
  // -------------------------------------------------------
  
  render() {
    let data = this.props.data;
    let event = this.state.event;
    
    return (
      <div className="upload-media">
        <S3Upload setEvent={this.setEvent.bind(this)} actionProgress={this.actionProgress.bind(this)} />
        
        { (this.state.upload_url != '') &&
          <div className="sample-media">
            <div className="thumbnail"><img src={this.state.upload_url} onError={(e)=>{e.target.src=this.state.upload_url}} /></div>
          </div>
        }
        { (this.state.upload_url == '' && data.default != '') &&
          <div className="sample-media">
            <div className="thumbnail"><img src={data.default} /></div>
          </div>
        }
        
        <label>
          <input type="file" name="example" size="30" onChange={(e) => { event.file_upload.bind(this)(e, 'project/') }} />
          <span><i className="material-icons">add_photo_alternate</i>ファイルを選択</span>
        </label>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InputImage;